import useResizeObserver from "@react-hook/resize-observer";
import { useRef, useEffect, useState, MutableRefObject } from "react";

import { useNavbarHeight } from "./useNavbarHeight";

export const useProductHeaderHeight = (
    withStickyAppBar: boolean,
    scrollableContainerRef?: MutableRefObject<HTMLDivElement | null>
) => {
    const scrollableContainerDom = scrollableContainerRef?.current;
    const headerRef = useRef<HTMLDivElement | null>(null);
    const [headerDomNodeBottom, setHeaderDomNodeBottom] = useState<number>();
    const navBarHeight = useNavbarHeight();
    const headerDomNode = headerRef.current;
    const isHeaderSticky = headerDomNode ? headerDomNode.getAttribute("data-is-fully-visible") : undefined;

    if (headerDomNode && isHeaderSticky === null) {
        throw new Error("Header 'data-is-fully-visible'-attribute is required!");
    }

    useEffect(() => {
        if (withStickyAppBar) return;

        let disabled = false;
        const onScroll = () => {
            if (!headerDomNode) return;
            const { top, bottom } = headerDomNode.getBoundingClientRect();
            const hasReachedTop = top === 0;
            if (!disabled || !hasReachedTop) {
                disabled = false;
                setHeaderDomNodeBottom(bottom - top);
            }
            if (hasReachedTop) disabled = true;
        };
        (scrollableContainerDom ?? window).addEventListener("scroll", onScroll);
        return () => (scrollableContainerDom ?? window).removeEventListener("scroll", onScroll);
    }, [headerDomNode, withStickyAppBar, scrollableContainerDom]);

    useResizeObserver(headerRef, (entry) => {
        const domRect = entry.target.getBoundingClientRect();
        setHeaderDomNodeBottom(domRect.bottom);
    });
    const headerHeight = isHeaderSticky ? headerDomNodeBottom : navBarHeight;
    return { headerRef, headerHeight };
};
